<div class="cmx-tags-v4-tag" *ngFor="let tag of tags">
    <div class="cmx-tags-v4-tag__message">{{ tag }}</div>
    <button class="cmx-tags-v4-tag__close button button--icon" (click)="OnDeleteTag(tag)">
        <span class="cmx-icon-close" aria-hidden="true"></span>
        <span class="sr-only">Dismiss Tag</span>
    </button>
</div>